import React from 'react';
import { useParams } from "react-router-dom";
import Header from '../components/Header';
import { Trade, SendVIP, TradeRecord } from './components';
import TabSwitcher from '../../Units/TabSwitcher';
import '../../../assets/stylesheets/ClubSlide/ClubCounter.scss';

const tabs = [
    {name: 'trade', view: Trade},
    // {name: 'sendVip', view: SendVIP},
    {name: 'tradeRecord', view: TradeRecord}
];
const ClubCounter = () => {
    const { id } = useParams();

    return (
        <div className={`clubCounter clubPage`}>
            <Header title={`counter`} to={`/club/${id}`} />
            <TabSwitcher tabs ={tabs} />
        </div>
    );
};

export default ClubCounter;
